<template>
  <!-- Popup Deposit -->
  <el-dialog title="Connect wallet" :visible.sync="isShowWalletProviderForm" class="connect-dialog medium"
    :close-on-click-modal="false"
    >
    <div class="popup-inner">
      <div class="item" @click="handleConnectWallet(TYPES_CONNECT.INJECT)">
        <span>Metamask</span>
        <img src="/assets/images/icons/metamask.svg" alt="Metamask">
      </div>
      <div class="item" @click="handleConnectWallet(TYPES_CONNECT.WALLET_CONNECT)">
        <span>WalletConnect</span>
        <img src="/assets/images/icons/walletconnect.svg" alt="Walletconnect">
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
// import getWeb3 from '@/utils/Web3Util'
import CONSTANT from '../../configs/constant'
export default {
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    web3 () {
      return this.$store.getters.web3
    },
    isShowWalletProviderForm: {
      get () {
        return this.$store.getters.isShowWalletProviderForm
      },
      set () {
        this.$store.dispatch('toggleWalletProviderForm')
      }
    },
    isValidated () {
      return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0
    }
  },
  created () {
    this.TYPES_CONNECT = CONSTANT.TYPES_CONNECT
  },
  methods: {
    // async connectWeb3 () {
    //   const web3 = await getWeb3()
    //   console.log(web3)
    // },
    // connectWallet () {
    //   this.$store.dispatch('walletConnectInit', true)
    // },
    handleConnectWallet (type) {
      this.$store.dispatch('handleConnectWallet', type)
    }
  }
}
</script>
